import { render } from "./VectorRight.svg?vue&type=template&id=c51b9d30"
const script = {}
script.render = render

export default script